'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchLiveCatalogStatusIfNeeded = exports.isLiveCatalogStatusLoading = exports.getLoadTimeForLiveCatalogStatus = exports.LOAD_LIVE_CATALOG_STATUS_SUCCESS = exports.LOAD_LIVE_CATALOG_STATUS_REQUEST = exports.LOAD_LIVE_CATALOG_STATUS_FAIL = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _user = require('./user');

var _api = require('../api');

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = require('reselect');

var _difference = require('lodash/difference');

var _difference2 = _interopRequireDefault(_difference);

var _liveBid = require('./liveBid');

var _config = require('./config');

var _ms = require('ms');

var _ms2 = _interopRequireDefault(_ms);

var _union = require('lodash/union');

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_LIVE_CATALOG_STATUS_FAIL = exports.LOAD_LIVE_CATALOG_STATUS_FAIL = 'la/domain/liveCatalogStatus/LOAD_FAIL';
var LOAD_LIVE_CATALOG_STATUS_REQUEST = exports.LOAD_LIVE_CATALOG_STATUS_REQUEST = 'la/domain/liveCatalogStatus/LOAD_REQUEST';
var LOAD_LIVE_CATALOG_STATUS_SUCCESS = exports.LOAD_LIVE_CATALOG_STATUS_SUCCESS = 'la/domain/liveCatalogStatus/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

/* reducer */
var DEFAULT_STATE = {
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var loaded = void 0;
    var loading = void 0;
    var time = void 0;

    switch (action.type) {
        case LOAD_LIVE_CATALOG_STATUS_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, action.meta.catalogId)
            });
        case LOAD_LIVE_CATALOG_STATUS_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: (0, _union2.default)(state.loading, action.payload)
            });
        case LOAD_LIVE_CATALOG_STATUS_SUCCESS:
            loaded = (0, _cloneDeep2.default)(state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            time = action.meta.actionTime;
            loaded[action.meta.catalogId] = time;

            return (0, _extends3.default)({}, state, {
                loaded: loaded,
                loading: (0, _difference2.default)(loading, [action.payload.catalogId])
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.liveCatalogStatus;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

var getLoadTimeForLiveCatalogStatus = exports.getLoadTimeForLiveCatalogStatus = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded[id] || 0;
});

var isLiveCatalogStatusLoading = exports.isLiveCatalogStatusLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.includes(id);
});

var shouldFetchLiveCatalogStatus = function shouldFetchLiveCatalogStatus(state, catalogId) {
    if (!catalogId) return false;
    var loaded = getLoadTimeForLiveCatalogStatus(state, catalogId);
    if (loaded) {
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    var loading = isLiveCatalogStatusLoading(state, catalogId);
    return !loading;
};

/* ACTION CREATORS */
var loadLiveCatalogStatus = function loadLiveCatalogStatus(catalogId) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, bidderId, authToken, email, deployment, source, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            bidderId = (0, _user.getBidderId)(state);
                            authToken = (0, _user.getAuthToken)(state);
                            email = (0, _user.getBidderEmail)(state);
                            deployment = (0, _config.getDeployment)(state);
                            source = (0, _liveBid.getBidSource)(state);

                            bidderId = bidderId === -1 ? false : bidderId;

                            dispatch({
                                payload: [catalogId],
                                type: LOAD_LIVE_CATALOG_STATUS_REQUEST
                            });

                            _context.next = 11;
                            return _api.LiveCatalogStatus.fetchLiveCatalogStatus({
                                authToken: authToken,
                                bidderId: bidderId,
                                catalogId: catalogId,
                                deployment: deployment,
                                email: email,
                                source: source
                            });

                        case 11:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now(), bidderId: bidderId, catalogId: catalogId },
                                payload: response.data,
                                type: LOAD_LIVE_CATALOG_STATUS_SUCCESS
                            });
                            _context.next = 18;
                            break;

                        case 15:
                            _context.prev = 15;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true, // TODO: this isn't used
                                meta: { catalogId: catalogId },
                                payload: _context.t0,
                                type: LOAD_LIVE_CATALOG_STATUS_FAIL
                            });

                        case 18:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 15]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

var fetchLiveCatalogStatusIfNeeded = exports.fetchLiveCatalogStatusIfNeeded = function fetchLiveCatalogStatusIfNeeded(catalogId) {
    return function (dispatch, getState) {
        if (shouldFetchLiveCatalogStatus(getState(), catalogId)) {
            return dispatch(loadLiveCatalogStatus(catalogId));
        }
        return _promise2.default.resolve();
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/liveCatalogStatus.js
// module id = ByEe
// module chunks = 60